export function parseAnswer(raw) {
  const data = { title: "", intro: "", story: "", reflection: "", illustration: "", verses: [] };
  const parts = raw.split(/(§TITLE§|§INTRO§|§STORY§|§VERSE§|§REFLECTION§|§ILLUSTRATION§)/);
  for (let i = 1; i < parts.length; i += 2) {
    const marker = parts[i].trim();
    const content = (parts[i + 1] || "").trim();
    if (marker === "§TITLE§") data.title = content;
    else if (marker === "§INTRO§") data.intro = content;
    else if (marker === "§STORY§") data.story = content;
    else if (marker === "§REFLECTION§") data.reflection = content;
    else if (marker === "§ILLUSTRATION§") data.illustration = content;
    else if (marker === "§VERSE§" && content.includes("|||")) {
      const idx = content.indexOf("|||");
      data.verses.push({ reference: content.slice(0, idx).trim(), text: content.slice(idx + 3).trim() });
    }
  }
  return data;
}
